import React, { Component } from 'react';
import axios from 'axios';

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Switch
} from '@material-ui/core';

import { authMiddleWare } from '../util/auth';

const styles = (theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  toolbar: theme.mixins.toolbar,
  uiProgess: {
    position: 'fixed',
    zIndex: 1000,
    height: '31px',
    width: '31px',
    left: '50%',
    top: '35%'
  },
  progess: {
    position: 'absolute'
  },
  customError: {
    color: 'red',
    fontSize: '0.8rem',
    marginTop: 10
  }
});

class Brand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brandTitle: '',
      brandDescription: '',
      brandActive: false,
      brandURL: '',
      brandIcon: '',
      brandInsta: '',
      brandFb: '',
      brandTik: '',

      uiLoading: true,
      buttonLoading: false,
      errorMsg: ''
    };
  }

  componentDidMount() {
    authMiddleWare(this.props.history);
    const authToken = localStorage.getItem('AuthToken');
    axios.defaults.headers.common = { Authorization: `${authToken}` };

    axios
      .get('/brand')
      .then((res) => {
        const data = res.data || {};
        this.setState({
          brandTitle: data.brandTitle || '',
          brandDescription: data.brandDescription || '',
          brandActive: !!data.brandActive,
          brandURL: data.brandURL || '',
          brandIcon: data.brandIcon || '',
          brandInsta: data.brandInsta || '',
          brandFb: data.brandFb || '',
          brandTik: data.brandTik || '',
          uiLoading: false,
          errorMsg: ''
        });
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 403) {
          this.props.history.push('/login');
          return;
        }
        this.setState({
          uiLoading: false,
          errorMsg: 'Brand konnte nicht geladen werden'
        });
      });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSwitch = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ buttonLoading: true, errorMsg: '' });

    authMiddleWare(this.props.history);
    const authToken = localStorage.getItem('AuthToken');
    axios.defaults.headers.common = { Authorization: `${authToken}` };

    const payload = {
      brandTitle: this.state.brandTitle,
      brandDescription: this.state.brandDescription,
      brandActive: this.state.brandActive,
      brandURL: this.state.brandURL,
      brandIcon: this.state.brandIcon,
      brandInsta: this.state.brandInsta,
      brandFb: this.state.brandFb,
      brandTik: this.state.brandTik
    };

    axios
      .put('/brand', payload)
      .then(() => {
        this.setState({ buttonLoading: false });
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 403) {
          this.props.history.push('/login');
          return;
        }
        this.setState({
          buttonLoading: false,
          errorMsg: 'Speichern fehlgeschlagen'
        });
      });
  };

  render() {
    const { classes } = this.props;

    if (this.state.uiLoading) {
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <CircularProgress size={150} className={classes.uiProgess} />
        </main>
      );
    }

    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />

        <Typography gutterBottom variant="h4">
          Brand
        </Typography>

        <Card>
          <form autoComplete="off" noValidate onSubmit={this.handleSubmit}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandTitle"
                    placeholder="Brand Title"
                    value={this.state.brandTitle}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.brandActive}
                        onChange={this.handleSwitch}
                        name="brandActive"
                        color="primary"
                      />
                    }
                    label="Aktiv"
                  />
                </Grid>

                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandDescription"
                    placeholder="Description"
                    multiline
                    rows={3}
                    value={this.state.brandDescription}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandURL"
                    placeholder="Website URL"
                    value={this.state.brandURL}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandIcon"
                    placeholder="Icon URL (extern)"
                    value={this.state.brandIcon}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandInsta"
                    placeholder="Instagram URL"
                    value={this.state.brandInsta}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandFb"
                    placeholder="Facebook URL"
                    value={this.state.brandFb}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    name="brandTik"
                    placeholder="TikTok URL"
                    value={this.state.brandTik}
                    onChange={this.handleChange}
                  />
                </Grid>

                {this.state.errorMsg ? (
                  <Grid item xs={12}>
                    <div className={classes.customError}>{this.state.errorMsg}</div>
                  </Grid>
                ) : null}

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    type="submit"
                    className="save_button"
                    onClick={this.handleSubmit}
                    disabled={this.state.buttonLoading}
                  >
                    Speichern
                    {this.state.buttonLoading && (
                      <CircularProgress size={30} className={classes.progess} />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </form>
        </Card>
      </main>
    );
  }
}

export default withStyles(styles)(Brand);